type LoggerLike = Pick<Console, "warn">;

export function isPlaceholderAiKey(key: string): boolean {
  return key.length < 20 || /^sk-\.{2,}$/.test(key) || key.includes("your-key") || key.includes("YOUR_KEY");
}

export function warnIfPlaceholderAiKey(env: NodeJS.ProcessEnv, logger: LoggerLike = console): void {
  const key = env.OPENAI_API_KEY || "";
  if (!key || !isPlaceholderAiKey(key)) {
    return;
  }
  logger.warn(`[gencow] ⚠️  OPENAI_API_KEY가 플레이스홀더입니다.`);
  logger.warn(`[gencow]    💡 로컬에서 AI 기능을 테스트하려면 실제 키를 .env에 설정하세요.`);
  logger.warn(`[gencow]    ☁️  클라우드 배포(gencow deploy) 후에는 키 설정 없이 자동 동작합니다.`);
}
